import { IcommercialAgentState } from 'interfaces/commercialAgent.interface';

const initialCommercialAgentState: IcommercialAgentState = {
  agents: [],
  agentSelected: null,
  isLoadingGetCommercialAgents: false,
  getCommercialAgents: () => Promise.resolve(false),
  selectAgent: () => {},
  createCommercialAgent: () => Promise.resolve(false),
  updateCommercialAgent: () => Promise.resolve(false),
  isLoadingCreateUpdateCommercialAgent: false,
  deleteCommercialAgent: () => Promise.resolve(false),
  isLoadingDeleteCommercialAgent: {
    isLoading: false,
    agentId: null,
  },
  assignAgentsToClient: () => Promise.resolve(false),
  isLoadingAssignAgentsToClient: false,
};

export default initialCommercialAgentState;
